import { FormEvent } from 'react';
import TabsController from '../../../../../../../common/tabs/TabsController';
import { previousValidationActions } from '../../../../../../../../store/previousValidationSlice';
import store from '../../../../../../../../store';
import { IApiaField, IApiaForm } from '../../../../../../../../JSApi/types';
import propsStore from '../../../../../../../../store/propsStore/propsStore';
import { arrayOrArray } from '../../../../../../../../utils/util';
import { TModify, getLabel } from '@apia/util';
import { IApiaSelect } from '../../../../../../../../types';
import { TProperties } from '../../../../../../../../store/propsStore/types';
import { getPossibleValue } from './getPossibleValue';
import { TTrConfirmProps } from '../../../components/OverrideFieldRow';
import { resolveFinalMessage } from './resolveFinalMessage';
import { getFormsAssistantConfiguration } from '../../../getFormsAssistantConfiguration';
import { TMessageType } from '@apia/ai';
import { TFieldValue } from './resolveResponseResult';

export const confirmNewValues = (
  ev: FormEvent<HTMLFormElement>,
  fillProps: {
    confirmProps: TTrConfirmProps[];
    confirmedValues: string[];
  },
  formResponse: {
    message: string;
    filledFormsMap: Record<string, Record<string, TFieldValue>>;
    type: TMessageType;
  },
  isPhone: boolean,
) => {
  ev.preventDefault();
  let shouldReplaceAll = false;
  const targetElem = ev.target as HTMLFormElement;
  if (isPhone) {
    const replaceTable = targetElem.querySelector(
      '#shouldReplace',
    ) as HTMLElement;
    if (replaceTable) {
      const discardAll = replaceTable
        .querySelector('#discardAll')
        ?.querySelector('input[type="checkbox"]') as HTMLInputElement;
      const replaceAll = replaceTable
        .querySelector('#replaceAll')
        ?.querySelector('input[type="checkbox"]') as HTMLInputElement;
      if (discardAll.checked) {
        shouldReplaceAll = false;
      } else if (replaceAll.checked) {
        shouldReplaceAll = true;
      }
    }
  }
  Object.values(
    (
      targetElem.querySelector('#confirmNewValues') as HTMLElement
    )?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]'),
  ).forEach((current) => {
    const tr = current.closest('tr') as HTMLTableRowElement;

    if (
      current instanceof HTMLInputElement &&
      tr instanceof HTMLTableRowElement &&
      ((current.checked && !isPhone) || shouldReplaceAll)
    ) {
      const formName: string = String(tr.dataset.formname);
      const fieldName: string = String(tr.dataset.fieldname);
      const form: IApiaForm | null = window.ApiaFunctions.getForm(formName);

      let actualValue: boolean | string | number | null = String(
        tr.dataset.newvalue,
      );
      if (form && fieldName !== 'undefined') {
        const result = fieldName.split('-_-', 2);
        const field: IApiaField | null = form.getField(
          result.length != 2 ? fieldName : result[1],
          result.length != 2 ? undefined : Number.parseInt(result[0]),
        );
        if (field) {
          const fieldProps = propsStore.getFieldProps(String(field.fldId));
          if ('check' === String(field.fldType)) {
            actualValue = actualValue === 'true' ? true : false;
          } else if (
            ['radio', 'select', 'multiple'].includes(String(field.fldType))
          ) {
            const possibleValues = arrayOrArray(
              (fieldProps.field as TModify<TProperties, IApiaSelect>)
                .possibleValue,
            );
            const possibleValue = getPossibleValue(
              possibleValues,
              actualValue,
              fieldProps.attributes.attLabel,
              null,
              null,
              actualValue,
            );
            if (possibleValue.actualValue)
              actualValue = possibleValue.actualValue;
            else return;
          }
          field.setValue(actualValue);
          fillProps.confirmedValues.push(
            result.length < 2
              ? fieldProps.attributes.attLabel
              : getLabel('lblAiActualGridFieldTitle', {
                  text: {
                    TOK1:
                      fieldProps.attributes.attLabel !== undefined &&
                      fieldProps.attributes.attLabel !== ''
                        ? fieldProps.attributes.attLabel
                        : result[1],
                    TOK2: result[0],
                  },
                }).text,
          );
        }
      } else if (
        formName === getFormsAssistantConfiguration().OBSERVATIONS.name
      ) {
        store.dispatch(
          previousValidationActions.setValue({
            name: 'txtComment',
            submitValue: actualValue,
            value: actualValue,
            form: 'executionData',
          }),
        );
        TabsController.openTab('currentObservations', false);
      }
    }
  });
  resolveFinalMessage(formResponse, fillProps.confirmedValues);
};
